
export class CustomLabelWrap extends HTMLElement {
  static observedAttributes = ["for","checked"];
  #connectedInputId=null;
  #connectedInput = null;
  #controlLabel=null;
  #parent=null;
  constructor() {
    super();
  }
 
  #setConnectedInput(){
  	if(this.#controlLabel.control){
    	this.#connectedInput=this.#controlLabel.control;
      if(this.#connectedInput){
        this.onCheckChange();
        this.#connectedInput.addEventListener('change', this.inputChanged);
        console.log(`connected input found ${this.#connectedInput}`,this.#connectedInput);
        const config = { attributes: true, childList: false, subtree: false };
        const observer = new MutationObserver(this.inputObservedChange);
        this.setAttribute("checked",this.#connectedInput.checked);
				observer.observe(this.#connectedInput, config);
      }
    }
  }
  #resetConnectedInput(){
  this.#connectedInput=null;
    this.#setConnectedInput();
  }
    #getParentProduct() {
    return this.closest(`main`) || this.closest(`body`) || null;
  }


  connectedCallback() {

    this.#parent=this.#getParentProduct();
   
    this.#controlLabel = this.querySelector("label");
    this.#connectedInputId=this.getAttribute("for");
    if (!(this.#controlLabel instanceof HTMLLabelElement)) throw new Error('controlLabel not found');	
    if(this.#controlLabel.control){
    	this.#setConnectedInput();
    }else{
    	 document.addEventListener("DOMContentLoaded", (event) => {
  			this.#setConnectedInput();
			});
    } 
	 }

onCheckChange=()=>{
	this.checkClass();
 if(this.#connectedInput?.checked){

 }	
}
inputObservedChange=(mutationList, observer)=>{
  for (const mutation of mutationList) {
  	console.log(`mutation ${mutation.target.id} ${mutation.target.checked}`)
      this.setAttribute("checked",mutation.target.checked);
  }
}
  inputChanged=(event)=>{
  	if (!(event.target instanceof Element)) return; 
    this.setAttribute("checked",event.target.checked);
  	document.querySelectorAll(`input[name="${event.target.name}"][data-checked="true"]:not(#${event.target.id})`).forEach((inputItem)=>{
    	inputItem.dataset.checked="false";
    });
    event.target.dataset.checked="true";
  }
   attributeChangedCallback(name, oldValue, newValue) {
    console.log(`${name} ${oldValue} ${newValue}`);
       this.onCheckChange();
  }
  checkClass(){
    if(!this.#connectedInput) return;
  	if(this.#connectedInput.checked){
      this.classList.add("checked")
    }else{
      this.classList.remove("checked")
    }
  }
}
  
  if (!customElements.get('custom-label-wrap')) {
  customElements.define('custom-label-wrap', CustomLabelWrap);
}
